export var VoiceMessageModeEnum;
(function (VoiceMessageModeEnum) {
    VoiceMessageModeEnum["TTS"] = "tts";
    VoiceMessageModeEnum["AUDIO"] = "audio";
})(VoiceMessageModeEnum || (VoiceMessageModeEnum = {}));
export var twilioTtsSupportedLocales = ['en', 'es', 'fr', 'pt', 'de', 'it', 'ru', 'pl', 'ja', 'ko', 'zh', 'nl', 'sv', 'no', 'da', 'fi'];
//# sourceMappingURL=voice-message.i.js.map